<template>
  <div>
    <span
      class="d-flex align-center v-label theme--light mt-1 b-hint"
      style="font-size: 0.9rem"
      :class="{
        'b-hint-bold': bold,
        'mb-2': marginBottom,
      }"
    >
      <v-icon class="mr-2" small>mdi-information-outline</v-icon>
      <span v-if="withHTML" v-html="hintText" />
      <div v-else :class="{ 'b-hint-underlined': underlined }">
        {{ hintText }}
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BHint',
  props: {
    hintText: { type: String, required: true },
    bold: { type: Boolean, default: false },
    marginBottom: { type: Boolean, default: true },
    withHTML: { type: Boolean, default: false },
    underlined: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.b-hint.b-hint-bold {
  font-weight: bold;
}
.b-hint-underlined {
  text-decoration: underline;
}
</style>
